import { PetSpecies } from '@/types/breeds';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Checkbox, Input, Select } from 'antd';
import React from 'react';

const { Option } = Select;

interface BreedsFiltersProps {
	searchTerm: string;
	selectedSpecies: string;
	selectedIsActive?: boolean;
	selectedIsPopular?: boolean;
	onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onSpeciesChange: (value: string) => void;
	onIsActiveChange: (value: boolean | undefined) => void;
	onIsPopularChange: (value: boolean) => void;
	onClearFilters: () => void;
}

export function BreedsFilters({
	searchTerm,
	selectedSpecies,
	selectedIsActive,
	selectedIsPopular,
	onSearch,
	onSpeciesChange,
	onIsActiveChange,
	onIsPopularChange,
	onClearFilters,
}: BreedsFiltersProps) {
	return (
		<div className="flex flex-col md:flex-row gap-4 items-center bg-white p-4 rounded-lg border border-gray-100 shadow-sm">
			<div className="flex-1 w-full md:w-auto">
				<Input
					placeholder="Search by name..."
					value={searchTerm}
					onChange={onSearch}
					prefix={<SearchOutlined className="text-gray-400" />}
					allowClear
				/>
			</div>

			<Select
				value={selectedSpecies}
				onChange={onSpeciesChange}
				className="w-full md:w-48"
				placeholder="Species"
				allowClear
			>
				<Option value="">All Species</Option>
				<Option value={PetSpecies.DOG}>Dog</Option>
				<Option value={PetSpecies.CAT}>Cat</Option>
				<Option value={PetSpecies.BIRD}>Bird</Option>
				<Option value={PetSpecies.RABBIT}>Rabbit</Option>
				<Option value={PetSpecies.HAMSTER}>Hamster</Option>
				<Option value={PetSpecies.FISH}>Fish</Option>
				<Option value={PetSpecies.REPTILE}>Reptile</Option>
				<Option value={PetSpecies.HORSE}>Horse</Option>
				<Option value={PetSpecies.OTHER}>Other</Option>
			</Select>

			<Select
				value={selectedIsActive === undefined ? '' : selectedIsActive.toString()}
				onChange={(value) => onIsActiveChange(value === '' ? undefined : value === 'true')}
				className="w-full md:w-32"
				placeholder="Status"
			>
				<Option value="">All Status</Option>
				<Option value="true">Active</Option>
				<Option value="false">Inactive</Option>
			</Select>

			<Checkbox
				checked={selectedIsPopular}
				onChange={(e) => onIsPopularChange(e.target.checked)}
			>
				Popular Only
			</Checkbox>

			<Button
				type="text"
				icon={<FilterOutlined />}
				onClick={onClearFilters}
				className="text-gray-500 hover:text-gray-700"
			>
				Reset
			</Button>
		</div>
	);
}

